export default "__VITE_ASSET__BjtQ2xwA__"